import { useEffect, useRef, useState } from 'react';

/**
 * BORRADOR CONTRA APLICADO de un panel de filtros.
 *
 * El panel edita `borrador`; la pantalla consulta con lo APLICADO, que sólo
 * cambia al pulsar «Aplicar» (o un atajo). `claveAplicado` es una llave de
 * texto de lo aplicado y `clave(borrador)` la del borrador en el MISMO formato:
 * si difieren, hay «Cambios sin aplicar».
 *
 * Cuando lo aplicado cambia —porque se aplicó, o desde fuera: un clic en una
 * fila de la tabla, el paso de Global a Tienda— el borrador se reinicia a lo
 * aplicado. Se compara por llave y no por referencia para que un objeto nuevo
 * con el mismo contenido no borre lo que el usuario está tecleando.
 *
 * ⚠️ Por lo mismo, aplicar algo IGUAL a lo aplicado no reinicia nada: la llave
 * no cambia. Quien aplica sin pasar por el borrador —los atajos— tiene que
 * dejar el borrador en lo que aplica con `setBorrador`; si no, un atajo pulsado
 * sobre sí mismo deja el panel con lo tecleado y «Cambios sin aplicar».
 */
export function useBorrador<B>(
  desdeAplicado: () => B,
  claveAplicado: string,
  clave: (b: B) => string,
): { borrador: B; setBorrador: (b: B | ((prev: B) => B)) => void; sucio: boolean } {
  const [borrador, setBorrador] = useState<B>(desdeAplicado);
  const ultima = useRef(claveAplicado);

  useEffect(() => {
    if (ultima.current === claveAplicado) return;
    ultima.current = claveAplicado;
    setBorrador(desdeAplicado());
    // `desdeAplicado` cambia de identidad en cada render; lo que importa es la llave.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [claveAplicado]);

  return { borrador, setBorrador, sucio: clave(borrador) !== claveAplicado };
}

export default useBorrador;
